import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { AgentUsage, type IAgentUsageProps } from './ui/AgentUsage'

export const checkUsageAgent = async (id: number, action: IAgentUsageProps['action']) => {
  const { data } = await AiCallingApi.getAgentUsage(id)
  if (data.inboxes.length) {
    const modalId = nanoid()
    modalStore.addModal({
      paddingContent: '0',
      id: modalId,
      type: ModalTypeList.DEFAULT,
      showHeader: false,
      showCloseButton: false,
      ModalContent: () => <AgentUsage data={data} action={action} />,
      primaryAction: {
        onAction: () => {
          modalStore.removeModal(modalId)
        },
        text: 'Close',
      },
    })
    return true
  } else {
    return false
  }
}
